import React from "react";

function EmptyState({ icon = "bi-inbox", title, text, action }) {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">
        <i className={`bi ${icon}`} />
      </div>
      <h6 className="mb-1">{title}</h6>
      {text && <p className="text-muted small mb-3">{text}</p>}
      {action}
    </div>
  );
}

export default EmptyState;
